module.exports = __webpack_public_path__ + "img/phone.76f05155.png";